module.exports = __webpack_public_path__ + "3562f4cef75616dd0ebcf3797c967517.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/id-card-front.svg
// module id = 1679
// module chunks = 2